export const baseUrl = "https://posapi.adenzo.co.ke/api/v1/";
